var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21,
    r: 21,
    fill: "#22A079"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3423 14.0718V17.5617L24.346 17.5655C30.7134 17.8638 35.5 19.1518 35.5 20.689C35.5 22.23 30.7134 23.5142 24.346 23.8126V35H18.6725V23.8126C12.2978 23.5104 7.5 22.2263 7.5 20.6853C7.5 19.1442 12.2941 17.8601 18.6725 17.5617V14.0718H10.8247V8.75H32.1902V14.0718H24.3423ZM24.3423 22.8532V22.857V22.8608C29.9638 22.604 34.1605 21.6068 34.1605 20.4133C34.1605 19.2198 29.9675 18.2227 24.3423 17.9658V21.8637C24.179 21.8788 23.3033 21.9543 21.5519 21.9543C20.0937 21.9543 19.0362 21.8901 18.6688 21.8637V17.962C13.0362 18.2151 8.82839 19.216 8.82839 20.4095C8.82839 21.6068 13.0325 22.604 18.6688 22.857V22.8532C19.0325 22.8721 20.0603 22.9137 21.526 22.9137C23.359 22.9137 24.1827 22.8646 24.3423 22.8532Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.549e25db8213ad5c1633b27c020739ac.svg";
export { ForwardRef as ReactComponent };